// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"d04a9152","563":"1d645fe9","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};